import { Col, Row } from "reactstrap";
import { AbbreviationIconType } from "../../../Types/IconsType";
import { FlagIconData } from "../../../Data/Icons/FlagIcons";
import { H5, H6 } from "../../../AbstractElements";

const FlagIconBody: React.FC<AbbreviationIconType> = ({ getIconTag }) => {
  return (
    <Row className="icon-lists flag-icons">
      {FlagIconData.map((icon, i) => (
        <Col xs="12" sm="6" xl="4" key={i} onClick={() => getIconTag(icon)}>
          <div className="d-flex">
            <i className={`flag-icon flag-icon-${icon.abbreviation}`}></i>
            <div className="flex-grow-1 align-self-center">
              <H5>{icon.abbreviation}</H5>
              <H6 className="mt-0">{icon.name}</H6>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};
export default FlagIconBody;
